<div class="analysing-container" *ngIf="isAnalysing; else resultTemplate">
  <div class="analysing-card">
    <div class="init-loading__morph-container" aria-hidden="true">
      <div class="init-loading__shape"></div>
      <div class="init-loading__shape"></div>
      <div class="init-loading__shape"></div>
    </div>
    <div class="analysing-text">
      Analysing your file<span class="init-loading__dots" aria-hidden="true"><span class="init-loading__dot">.</span><span class="init-loading__dot">.</span><span class="init-loading__dot">.</span></span>
    </div>
    <div class="analysing-subtext">This may take up to 2 minutes</div>
  </div>
</div>

<ng-template #resultTemplate>
  <div class="result-container" *ngIf="result || error">
    <div class="result-card" *ngIf="result">
      <!-- result content will be added later -->
      <p>Result: {{ result.result ? 'Compatible' : 'Not compatible' }}</p>
    </div>
    <div class="error-card" *ngIf="error">
      <mat-icon class="error-icon">error_outline</mat-icon>
      <span class="error-text">{{ error }}</span>
      <button class="retry-btn" (click)="analyse()">Retry</button>
    </div>
  </div>
</ng-template>
